import React, { useState } from 'react';
import cx from 'classnames';
import styles from './InlinePagination.module.css';

export default ({
  children, initial = 5, step = 5, buttonClass, buttonText = 'Show More',
}) => {
  const [visibleEntries, setVisibleEntries] = useState(initial);

  return (
    <>
      {children.slice(0, (visibleEntries >= 0) ? visibleEntries : children.length)}
      {visibleEntries >= 0 && (children.length > visibleEntries) && (
        <button
          type="button"
          className={cx(styles.button, buttonClass)}
          onClick={() => setVisibleEntries(visibleEntries + step)}
        >
          {buttonText}
        </button>
      )}
    </>
  );
};
